// extracted by mini-css-extract-plugin
export default {"table":"nui-GhCcinl1"};